@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.chat.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.chat.resources/"

@delegate:ResourceContentHash(286_504_781)
internal val Res.string.channel_composer_placeholder: StringResource by lazy {
      StringResource("string:channel_composer_placeholder", "channel_composer_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 60),
      ))
    }

@delegate:ResourceContentHash(-347_782_272)
internal val Res.string.channel_empty_desc: StringResource by lazy {
      StringResource("string:channel_empty_desc", "channel_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 111, 246),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 79, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71, 122),
      ))
    }

@delegate:ResourceContentHash(462_638_315)
internal val Res.string.channel_empty_title: StringResource by lazy {
      StringResource("string:channel_empty_title", "channel_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 358, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194, 47),
      ))
    }

@delegate:ResourceContentHash(1_718_499_823)
internal val Res.string.channel_error: StringResource by lazy {
      StringResource("string:channel_error", "channel_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 422, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 294, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242, 61),
      ))
    }

@delegate:ResourceContentHash(1_241_412_880)
internal val Res.string.channel_follow: StringResource by lazy {
      StringResource("string:channel_follow", "channel_follow", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 562, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 398, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342, 30),
      ))
    }

@delegate:ResourceContentHash(1_976_169_267)
internal val Res.string.channel_following: StringResource by lazy {
      StringResource("string:channel_following", "channel_following", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 500, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 360, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 304, 37),
      ))
    }

@delegate:ResourceContentHash(1_371_152_013)
internal val Res.string.channel_label: StringResource by lazy {
      StringResource("string:channel_label", "channel_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 613, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 429, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 373, 45),
      ))
    }

@delegate:ResourceContentHash(-1_887_977_715)
internal val Res.string.channel_owner_intro: StringResource by lazy {
      StringResource("string:channel_owner_intro", "channel_owner_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 671, 327),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 479, 199),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 419, 171),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.channel_retry: StringResource by lazy {
      StringResource("string:channel_retry", "channel_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 999, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 679, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 591, 33),
      ))
    }

@delegate:ResourceContentHash(1_342_948_025)
internal val Res.string.channel_send_a11y: StringResource by lazy {
      StringResource("string:channel_send_a11y", "channel_send_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1049, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 717, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 625, 45),
      ))
    }

@delegate:ResourceContentHash(812_158_875)
internal val Res.string.channel_time_days_ago: StringResource by lazy {
      StringResource("string:channel_time_days_ago", "channel_time_days_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1123, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 771, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 671, 45),
      ))
    }

@delegate:ResourceContentHash(2_094_969_652)
internal val Res.string.channel_time_hours_ago: StringResource by lazy {
      StringResource("string:channel_time_hours_ago", "channel_time_hours_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1177, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 821, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 717, 46),
      ))
    }

@delegate:ResourceContentHash(-2_012_089_126)
internal val Res.string.channel_time_just_now: StringResource by lazy {
      StringResource("string:channel_time_just_now", "channel_time_just_now", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1236, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 872, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 764, 41),
      ))
    }

@delegate:ResourceContentHash(-1_591_511_977)
internal val Res.string.channel_time_minutes_ago: StringResource by lazy {
      StringResource("string:channel_time_minutes_ago", "channel_time_minutes_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1290, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 922, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 806, 48),
      ))
    }

@delegate:ResourceContentHash(-1_205_191_231)
internal val Res.string.channel_time_weeks_ago: StringResource by lazy {
      StringResource("string:channel_time_weeks_ago", "channel_time_weeks_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1355, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 975, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 855, 46),
      ))
    }

@delegate:ResourceContentHash(339_358_431)
internal val Res.string.chat_block_cancel: StringResource by lazy {
      StringResource("string:chat_block_cancel", "chat_block_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1414, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1030, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 902, 33),
      ))
    }

@delegate:ResourceContentHash(-81_181_810)
internal val Res.string.chat_block_confirm: StringResource by lazy {
      StringResource("string:chat_block_confirm", "chat_block_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1456, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1068, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 936, 34),
      ))
    }

@delegate:ResourceContentHash(2_028_248_183)
internal val Res.string.chat_block_message: StringResource by lazy {
      StringResource("string:chat_block_message", "chat_block_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1511, 190),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1107, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 971, 114),
      ))
    }

@delegate:ResourceContentHash(-1_985_525_260)
internal val Res.string.chat_block_title: StringResource by lazy {
      StringResource("string:chat_block_title", "chat_block_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1787, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1307, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1143, 40),
      ))
    }

@delegate:ResourceContentHash(82_622_583)
internal val Res.string.chat_block_title_generic: StringResource by lazy {
      StringResource("string:chat_block_title_generic", "chat_block_title_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1702, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1238, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1086, 56),
      ))
    }

@delegate:ResourceContentHash(1_867_597_297)
internal val Res.string.chat_block_user_a11y: StringResource by lazy {
      StringResource("string:chat_block_user_a11y", "chat_block_user_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1844, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1352, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1184, 44),
      ))
    }

@delegate:ResourceContentHash(693_155_732)
internal val Res.string.chat_quick_available: StringResource by lazy {
      StringResource("string:chat_quick_available", "chat_quick_available", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1913, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1413, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1229, 60),
      ))
    }

@delegate:ResourceContentHash(-188_664_785)
internal val Res.string.chat_quick_meet: StringResource by lazy {
      StringResource("string:chat_quick_meet", "chat_quick_meet", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1982, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1482, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1290, 47),
      ))
    }

@delegate:ResourceContentHash(-65_013_718)
internal val Res.string.chat_quick_price: StringResource by lazy {
      StringResource("string:chat_quick_price", "chat_quick_price", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2078, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1542, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1338, 56),
      ))
    }

@delegate:ResourceContentHash(-481_935_050)
internal val Res.string.chat_report_done: StringResource by lazy {
      StringResource("string:chat_report_done", "chat_report_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2159, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1607, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1395, 32),
      ))
    }

@delegate:ResourceContentHash(-1_500_097_184)
internal val Res.string.chat_report_failed: StringResource by lazy {
      StringResource("string:chat_report_failed", "chat_report_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2196, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1644, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1428, 82),
      ))
    }

@delegate:ResourceContentHash(-395_251_490)
internal val Res.string.chat_report_reason_harassment: StringResource by lazy {
      StringResource("string:chat_report_reason_harassment", "chat_report_reason_harassment", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2319, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1743, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1511, 69),
      ))
    }

@delegate:ResourceContentHash(-283_302_589)
internal val Res.string.chat_report_reason_offensive: StringResource by lazy {
      StringResource("string:chat_report_reason_offensive", "chat_report_reason_offensive", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2389, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1821, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1581, 60),
      ))
    }

@delegate:ResourceContentHash(-318_576_167)
internal val Res.string.chat_report_reason_scam: StringResource by lazy {
      StringResource("string:chat_report_reason_scam", "chat_report_reason_scam", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2474, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1882, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1642, 51),
      ))
    }

@delegate:ResourceContentHash(1_511_516_124)
internal val Res.string.chat_report_reason_spam: StringResource by lazy {
      StringResource("string:chat_report_reason_spam", "chat_report_reason_spam", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2554, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1938, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1694, 59),
      ))
    }

@delegate:ResourceContentHash(-1_054_499_435)
internal val Res.string.chat_report_submit: StringResource by lazy {
      StringResource("string:chat_report_submit", "chat_report_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2634, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2002, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1754, 46),
      ))
    }

@delegate:ResourceContentHash(521_288_727)
internal val Res.string.chat_report_user_a11y: StringResource by lazy {
      StringResource("string:chat_report_user_a11y", "chat_report_user_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2689, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2061, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1801, 45),
      ))
    }

@delegate:ResourceContentHash(-1_854_301_679)
internal val Res.string.chat_report_user_sent: StringResource by lazy {
      StringResource("string:chat_report_user_sent", "chat_report_user_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2747, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2123, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1847, 85),
      ))
    }

@delegate:ResourceContentHash(-155_922_936)
internal val Res.string.chat_report_user_title: StringResource by lazy {
      StringResource("string:chat_report_user_title", "chat_report_user_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2885, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2221, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1933, 54),
      ))
    }

@delegate:ResourceContentHash(-1_908_861_698)
internal val Res.string.chat_safety_note: StringResource by lazy {
      StringResource("string:chat_safety_note", "chat_safety_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2956, 252),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2284, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1988, 132),
      ))
    }

@delegate:ResourceContentHash(694_672_154)
internal val Res.string.chat_send_failed: StringResource by lazy {
      StringResource("string:chat_send_failed", "chat_send_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3209, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2457, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2121, 76),
      ))
    }

@delegate:ResourceContentHash(1_829_074_531)
internal val Res.string.chat_time_am: StringResource by lazy {
      StringResource("string:chat_time_am", "chat_time_am", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3334, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2546, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2198, 24),
      ))
    }

@delegate:ResourceContentHash(-1_465_652_660)
internal val Res.string.chat_time_days_ago: StringResource by lazy {
      StringResource("string:chat_time_days_ago", "chat_time_days_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3363, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2571, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2223, 34),
      ))
    }

@delegate:ResourceContentHash(-1_059_683_197)
internal val Res.string.chat_time_hours_ago: StringResource by lazy {
      StringResource("string:chat_time_hours_ago", "chat_time_hours_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3406, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2606, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2258, 35),
      ))
    }

@delegate:ResourceContentHash(1_105_756_801)
internal val Res.string.chat_time_just_now: StringResource by lazy {
      StringResource("string:chat_time_just_now", "chat_time_just_now", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3454, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2642, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2294, 30),
      ))
    }

@delegate:ResourceContentHash(-1_152_130_377)
internal val Res.string.chat_time_minutes_ago: StringResource by lazy {
      StringResource("string:chat_time_minutes_ago", "chat_time_minutes_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3505, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2689, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2325, 37),
      ))
    }

@delegate:ResourceContentHash(2_111_656_951)
internal val Res.string.chat_time_pm: StringResource by lazy {
      StringResource("string:chat_time_pm", "chat_time_pm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3555, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2731, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2363, 24),
      ))
    }

@delegate:ResourceContentHash(-866_066_164)
internal val Res.string.chat_time_weeks_ago: StringResource by lazy {
      StringResource("string:chat_time_weeks_ago", "chat_time_weeks_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3584, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2756, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2388, 35),
      ))
    }

@delegate:ResourceContentHash(-696_553_016)
internal val Res.string.chat_unnamed_member: StringResource by lazy {
      StringResource("string:chat_unnamed_member", "chat_unnamed_member", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3632, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2796, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2424, 47),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.convo_back_a11y: StringResource by lazy {
      StringResource("string:convo_back_a11y", "convo_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3680, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2844, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2472, 31),
      ))
    }

@delegate:ResourceContentHash(552_105_112)
internal val Res.string.convo_empty_desc: StringResource by lazy {
      StringResource("string:convo_empty_desc", "convo_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3720, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2876, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2504, 76),
      ))
    }

@delegate:ResourceContentHash(1_515_912_637)
internal val Res.string.convo_empty_title: StringResource by lazy {
      StringResource("string:convo_empty_title", "convo_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3801, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2957, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2581, 41),
      ))
    }

@delegate:ResourceContentHash(1_307_803_953)
internal val Res.string.convo_error: StringResource by lazy {
      StringResource("string:convo_error", "convo_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3851, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2999, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2623, 63),
      ))
    }

@delegate:ResourceContentHash(-1_838_260_855)
internal val Res.string.convo_group_request_note: StringResource by lazy {
      StringResource("string:convo_group_request_note", "convo_group_request_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3947, 176),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3071, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2687, 124),
      ))
    }

@delegate:ResourceContentHash(-1_465_151_767)
internal val Res.string.convo_input_placeholder: StringResource by lazy {
      StringResource("string:convo_input_placeholder", "convo_input_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4124, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3208, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2812, 55),
      ))
    }

@delegate:ResourceContentHash(134_896_406)
internal val Res.string.convo_leave_group: StringResource by lazy {
      StringResource("string:convo_leave_group", "convo_leave_group", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4192, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3272, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2868, 41),
      ))
    }

@delegate:ResourceContentHash(456_494_511)
internal val Res.string.convo_request_accept: StringResource by lazy {
      StringResource("string:convo_request_accept", "convo_request_accept", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4238, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3322, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2910, 36),
      ))
    }

@delegate:ResourceContentHash(104_567_965)
internal val Res.string.convo_request_decline: StringResource by lazy {
      StringResource("string:convo_request_decline", "convo_request_decline", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4287, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3363, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2947, 41),
      ))
    }

@delegate:ResourceContentHash(-128_001_746)
internal val Res.string.convo_request_note: StringResource by lazy {
      StringResource("string:convo_request_note", "convo_request_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4337, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3405, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2989, 70),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.convo_retry: StringResource by lazy {
      StringResource("string:convo_retry", "convo_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4448, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3484, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3060, 31),
      ))
    }

@delegate:ResourceContentHash(-348_081_350)
internal val Res.string.convo_send_a11y: StringResource by lazy {
      StringResource("string:convo_send_a11y", "convo_send_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4496, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3520, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3092, 39),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.inbox_back_a11y: StringResource by lazy {
      StringResource("string:inbox_back_a11y", "inbox_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4548, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3568, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3132, 31),
      ))
    }

@delegate:ResourceContentHash(-307_201_611)
internal val Res.string.inbox_channels_section: StringResource by lazy {
      StringResource("string:inbox_channels_section", "inbox_channels_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4588, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3600, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3164, 42),
      ))
    }

@delegate:ResourceContentHash(-2_126_690_330)
internal val Res.string.inbox_empty_desc: StringResource by lazy {
      StringResource("string:inbox_empty_desc", "inbox_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4643, 212),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3639, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3207, 120),
      ))
    }

@delegate:ResourceContentHash(64_683_701)
internal val Res.string.inbox_empty_title: StringResource by lazy {
      StringResource("string:inbox_empty_title", "inbox_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4856, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3792, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3328, 45),
      ))
    }

@delegate:ResourceContentHash(-362_306_778)
internal val Res.string.inbox_error: StringResource by lazy {
      StringResource("string:inbox_error", "inbox_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4926, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3858, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3374, 59),
      ))
    }

@delegate:ResourceContentHash(-784_944_236)
internal val Res.string.inbox_messages_section: StringResource by lazy {
      StringResource("string:inbox_messages_section", "inbox_messages_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5014, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3926, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3434, 42),
      ))
    }

@delegate:ResourceContentHash(-930_161_042)
internal val Res.string.inbox_new_message_a11y: StringResource by lazy {
      StringResource("string:inbox_new_message_a11y", "inbox_new_message_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5065, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3969, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3477, 46),
      ))
    }

@delegate:ResourceContentHash(1_481_869_371)
internal val Res.string.inbox_people_a11y: StringResource by lazy {
      StringResource("string:inbox_people_a11y", "inbox_people_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5120, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4020, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3524, 49),
      ))
    }

@delegate:ResourceContentHash(-275_971_156)
internal val Res.string.inbox_requests_section: StringResource by lazy {
      StringResource("string:inbox_requests_section", "inbox_requests_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5186, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4070, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3574, 50),
      ))
    }

@delegate:ResourceContentHash(-574_583_101)
internal val Res.string.inbox_retry: StringResource by lazy {
      StringResource("string:inbox_retry", "inbox_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5257, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4121, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3625, 31),
      ))
    }

@delegate:ResourceContentHash(179_052_421)
internal val Res.string.inbox_search_placeholder: StringResource by lazy {
      StringResource("string:inbox_search_placeholder", "inbox_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5293, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4149, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3657, 64),
      ))
    }

@delegate:ResourceContentHash(-784_944_236)
internal val Res.string.inbox_title: StringResource by lazy {
      StringResource("string:inbox_title", "inbox_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5382, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4226, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3722, 31),
      ))
    }

@delegate:ResourceContentHash(805_997_247)
internal val Res.string.inbox_unread_a11y: StringResource by lazy {
      StringResource("string:inbox_unread_a11y", "inbox_unread_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5422, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4258, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3754, 53),
      ))
    }

@delegate:ResourceContentHash(1_555_410_801)
internal val Res.string.new_group_create: StringResource by lazy {
      StringResource("string:new_group_create", "new_group_create", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5500, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4312, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3808, 40),
      ))
    }

@delegate:ResourceContentHash(-835_607_072)
internal val Res.string.new_group_name_label: StringResource by lazy {
      StringResource("string:new_group_name_label", "new_group_name_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5549, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4361, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3849, 44),
      ))
    }

@delegate:ResourceContentHash(-2_024_825_705)
internal val Res.string.new_group_name_placeholder: StringResource by lazy {
      StringResource("string:new_group_name_placeholder", "new_group_name_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5598, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4410, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3894, 62),
      ))
    }

@delegate:ResourceContentHash(272_062_844)
internal val Res.string.new_group_title: StringResource by lazy {
      StringResource("string:new_group_title", "new_group_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5685, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4485, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3957, 35),
      ))
    }

@delegate:ResourceContentHash(1_218_481_965)
internal val Res.string.new_message_empty: StringResource by lazy {
      StringResource("string:new_message_empty", "new_message_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5733, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4529, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3993, 45),
      ))
    }

@delegate:ResourceContentHash(975_345_878)
internal val Res.string.new_message_hint: StringResource by lazy {
      StringResource("string:new_message_hint", "new_message_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5791, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4587, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4039, 76),
      ))
    }

@delegate:ResourceContentHash(2_063_772_101)
internal val Res.string.new_message_search_placeholder: StringResource by lazy {
      StringResource("string:new_message_search_placeholder", "new_message_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5904, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4684, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4116, 66),
      ))
    }

@delegate:ResourceContentHash(-930_161_042)
internal val Res.string.new_message_title: StringResource by lazy {
      StringResource("string:new_message_title", "new_message_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6003, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4767, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4183, 41),
      ))
    }

@delegate:ResourceContentHash(165_187_252)
internal val Res.string.people_bio_label: StringResource by lazy {
      StringResource("string:people_bio_label", "people_bio_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6053, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4813, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4225, 52),
      ))
    }

@delegate:ResourceContentHash(-965_082_825)
internal val Res.string.people_connect: StringResource by lazy {
      StringResource("string:people_connect", "people_connect", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6138, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4870, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4278, 34),
      ))
    }

@delegate:ResourceContentHash(-834_418_926)
internal val Res.string.people_edit_card: StringResource by lazy {
      StringResource("string:people_edit_card", "people_edit_card", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6177, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4905, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4313, 36),
      ))
    }

@delegate:ResourceContentHash(-1_895_824_831)
internal val Res.string.people_empty_desc: StringResource by lazy {
      StringResource("string:people_empty_desc", "people_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6222, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4942, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4350, 101),
      ))
    }

@delegate:ResourceContentHash(1_742_102_717)
internal val Res.string.people_empty_title: StringResource by lazy {
      StringResource("string:people_empty_title", "people_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6400, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5052, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4452, 46),
      ))
    }

@delegate:ResourceContentHash(-378_505_263)
internal val Res.string.people_filter_all: StringResource by lazy {
      StringResource("string:people_filter_all", "people_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6475, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5119, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4499, 37),
      ))
    }

@delegate:ResourceContentHash(-368_705_538)
internal val Res.string.people_intent_chatting: StringResource by lazy {
      StringResource("string:people_intent_chatting", "people_intent_chatting", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6509, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5165, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4537, 42),
      ))
    }

@delegate:ResourceContentHash(1_539_664_935)
internal val Res.string.people_intent_friends: StringResource by lazy {
      StringResource("string:people_intent_friends", "people_intent_friends", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6560, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5204, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4580, 49),
      ))
    }

@delegate:ResourceContentHash(653_140_909)
internal val Res.string.people_intent_meet: StringResource by lazy {
      StringResource("string:people_intent_meet", "people_intent_meet", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6618, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5258, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4630, 46),
      ))
    }

@delegate:ResourceContentHash(1_693_852_424)
internal val Res.string.people_intent_networking: StringResource by lazy {
      StringResource("string:people_intent_networking", "people_intent_networking", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6697, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5313, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4677, 48),
      ))
    }

@delegate:ResourceContentHash(-1_446_812_938)
internal val Res.string.people_join_desc: StringResource by lazy {
      StringResource("string:people_join_desc", "people_join_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6770, 472),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5362, 340),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4726, 284),
      ))
    }

@delegate:ResourceContentHash(-1_766_394_603)
internal val Res.string.people_join_title: StringResource by lazy {
      StringResource("string:people_join_title", "people_join_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7243, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5703, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5011, 53),
      ))
    }

@delegate:ResourceContentHash(-411_061_568)
internal val Res.string.people_map_approx_note: StringResource by lazy {
      StringResource("string:people_map_approx_note", "people_map_approx_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7333, 162),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5765, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5065, 98),
      ))
    }

@delegate:ResourceContentHash(526_931_105)
internal val Res.string.people_map_attribution: StringResource by lazy {
      StringResource("string:people_map_attribution", "people_map_attribution", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7496, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5904, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5164, 54),
      ))
    }

@delegate:ResourceContentHash(-861_593_607)
internal val Res.string.people_map_check_in: StringResource by lazy {
      StringResource("string:people_map_check_in", "people_map_check_in", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8561, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6653, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5805, 55),
      ))
    }

@delegate:ResourceContentHash(-931_698_711)
internal val Res.string.people_map_check_in_confirm: StringResource by lazy {
      StringResource("string:people_map_check_in_confirm", "people_map_check_in_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7551, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5959, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5219, 63),
      ))
    }

@delegate:ResourceContentHash(-1_823_956_977)
internal val Res.string.people_map_check_in_desc: StringResource by lazy {
      StringResource("string:people_map_check_in_desc", "people_map_check_in_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7643, 332),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6031, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5283, 184),
      ))
    }

@delegate:ResourceContentHash(1_463_203_597)
internal val Res.string.people_map_check_in_failed: StringResource by lazy {
      StringResource("string:people_map_check_in_failed", "people_map_check_in_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7976, 146),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6252, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5468, 98),
      ))
    }

@delegate:ResourceContentHash(-1_572_894_523)
internal val Res.string.people_map_check_in_list_note: StringResource by lazy {
      StringResource("string:people_map_check_in_list_note", "people_map_check_in_list_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8123, 185),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6363, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5567, 109),
      ))
    }

@delegate:ResourceContentHash(2_120_225_292)
internal val Res.string.people_map_check_in_no_location: StringResource by lazy {
      StringResource("string:people_map_check_in_no_location", "people_map_check_in_no_location", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8309, 251),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6497, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5677, 127),
      ))
    }

@delegate:ResourceContentHash(550_246_564)
internal val Res.string.people_map_checked_in: StringResource by lazy {
      StringResource("string:people_map_checked_in", "people_map_checked_in", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8637, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6713, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5861, 85),
      ))
    }

@delegate:ResourceContentHash(-803_874_494)
internal val Res.string.people_map_cluster_a11y: StringResource by lazy {
      StringResource("string:people_map_cluster_a11y", "people_map_cluster_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8767, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6807, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5947, 59),
      ))
    }

@delegate:ResourceContentHash(-594_665_564)
internal val Res.string.people_map_leave: StringResource by lazy {
      StringResource("string:people_map_leave", "people_map_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8835, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6871, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6007, 44),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("channel_composer_placeholder", Res.string.channel_composer_placeholder)
  map.put("channel_empty_desc", Res.string.channel_empty_desc)
  map.put("channel_empty_title", Res.string.channel_empty_title)
  map.put("channel_error", Res.string.channel_error)
  map.put("channel_follow", Res.string.channel_follow)
  map.put("channel_following", Res.string.channel_following)
  map.put("channel_label", Res.string.channel_label)
  map.put("channel_owner_intro", Res.string.channel_owner_intro)
  map.put("channel_retry", Res.string.channel_retry)
  map.put("channel_send_a11y", Res.string.channel_send_a11y)
  map.put("channel_time_days_ago", Res.string.channel_time_days_ago)
  map.put("channel_time_hours_ago", Res.string.channel_time_hours_ago)
  map.put("channel_time_just_now", Res.string.channel_time_just_now)
  map.put("channel_time_minutes_ago", Res.string.channel_time_minutes_ago)
  map.put("channel_time_weeks_ago", Res.string.channel_time_weeks_ago)
  map.put("chat_block_cancel", Res.string.chat_block_cancel)
  map.put("chat_block_confirm", Res.string.chat_block_confirm)
  map.put("chat_block_message", Res.string.chat_block_message)
  map.put("chat_block_title", Res.string.chat_block_title)
  map.put("chat_block_title_generic", Res.string.chat_block_title_generic)
  map.put("chat_block_user_a11y", Res.string.chat_block_user_a11y)
  map.put("chat_quick_available", Res.string.chat_quick_available)
  map.put("chat_quick_meet", Res.string.chat_quick_meet)
  map.put("chat_quick_price", Res.string.chat_quick_price)
  map.put("chat_report_done", Res.string.chat_report_done)
  map.put("chat_report_failed", Res.string.chat_report_failed)
  map.put("chat_report_reason_harassment", Res.string.chat_report_reason_harassment)
  map.put("chat_report_reason_offensive", Res.string.chat_report_reason_offensive)
  map.put("chat_report_reason_scam", Res.string.chat_report_reason_scam)
  map.put("chat_report_reason_spam", Res.string.chat_report_reason_spam)
  map.put("chat_report_submit", Res.string.chat_report_submit)
  map.put("chat_report_user_a11y", Res.string.chat_report_user_a11y)
  map.put("chat_report_user_sent", Res.string.chat_report_user_sent)
  map.put("chat_report_user_title", Res.string.chat_report_user_title)
  map.put("chat_safety_note", Res.string.chat_safety_note)
  map.put("chat_send_failed", Res.string.chat_send_failed)
  map.put("chat_time_am", Res.string.chat_time_am)
  map.put("chat_time_days_ago", Res.string.chat_time_days_ago)
  map.put("chat_time_hours_ago", Res.string.chat_time_hours_ago)
  map.put("chat_time_just_now", Res.string.chat_time_just_now)
  map.put("chat_time_minutes_ago", Res.string.chat_time_minutes_ago)
  map.put("chat_time_pm", Res.string.chat_time_pm)
  map.put("chat_time_weeks_ago", Res.string.chat_time_weeks_ago)
  map.put("chat_unnamed_member", Res.string.chat_unnamed_member)
  map.put("convo_back_a11y", Res.string.convo_back_a11y)
  map.put("convo_empty_desc", Res.string.convo_empty_desc)
  map.put("convo_empty_title", Res.string.convo_empty_title)
  map.put("convo_error", Res.string.convo_error)
  map.put("convo_group_request_note", Res.string.convo_group_request_note)
  map.put("convo_input_placeholder", Res.string.convo_input_placeholder)
  map.put("convo_leave_group", Res.string.convo_leave_group)
  map.put("convo_request_accept", Res.string.convo_request_accept)
  map.put("convo_request_decline", Res.string.convo_request_decline)
  map.put("convo_request_note", Res.string.convo_request_note)
  map.put("convo_retry", Res.string.convo_retry)
  map.put("convo_send_a11y", Res.string.convo_send_a11y)
  map.put("inbox_back_a11y", Res.string.inbox_back_a11y)
  map.put("inbox_channels_section", Res.string.inbox_channels_section)
  map.put("inbox_empty_desc", Res.string.inbox_empty_desc)
  map.put("inbox_empty_title", Res.string.inbox_empty_title)
  map.put("inbox_error", Res.string.inbox_error)
  map.put("inbox_messages_section", Res.string.inbox_messages_section)
  map.put("inbox_new_message_a11y", Res.string.inbox_new_message_a11y)
  map.put("inbox_people_a11y", Res.string.inbox_people_a11y)
  map.put("inbox_requests_section", Res.string.inbox_requests_section)
  map.put("inbox_retry", Res.string.inbox_retry)
  map.put("inbox_search_placeholder", Res.string.inbox_search_placeholder)
  map.put("inbox_title", Res.string.inbox_title)
  map.put("inbox_unread_a11y", Res.string.inbox_unread_a11y)
  map.put("new_group_create", Res.string.new_group_create)
  map.put("new_group_name_label", Res.string.new_group_name_label)
  map.put("new_group_name_placeholder", Res.string.new_group_name_placeholder)
  map.put("new_group_title", Res.string.new_group_title)
  map.put("new_message_empty", Res.string.new_message_empty)
  map.put("new_message_hint", Res.string.new_message_hint)
  map.put("new_message_search_placeholder", Res.string.new_message_search_placeholder)
  map.put("new_message_title", Res.string.new_message_title)
  map.put("people_bio_label", Res.string.people_bio_label)
  map.put("people_connect", Res.string.people_connect)
  map.put("people_edit_card", Res.string.people_edit_card)
  map.put("people_empty_desc", Res.string.people_empty_desc)
  map.put("people_empty_title", Res.string.people_empty_title)
  map.put("people_filter_all", Res.string.people_filter_all)
  map.put("people_intent_chatting", Res.string.people_intent_chatting)
  map.put("people_intent_friends", Res.string.people_intent_friends)
  map.put("people_intent_meet", Res.string.people_intent_meet)
  map.put("people_intent_networking", Res.string.people_intent_networking)
  map.put("people_join_desc", Res.string.people_join_desc)
  map.put("people_join_title", Res.string.people_join_title)
  map.put("people_map_approx_note", Res.string.people_map_approx_note)
  map.put("people_map_attribution", Res.string.people_map_attribution)
  map.put("people_map_check_in", Res.string.people_map_check_in)
  map.put("people_map_check_in_confirm", Res.string.people_map_check_in_confirm)
  map.put("people_map_check_in_desc", Res.string.people_map_check_in_desc)
  map.put("people_map_check_in_failed", Res.string.people_map_check_in_failed)
  map.put("people_map_check_in_list_note", Res.string.people_map_check_in_list_note)
  map.put("people_map_check_in_no_location", Res.string.people_map_check_in_no_location)
  map.put("people_map_checked_in", Res.string.people_map_checked_in)
  map.put("people_map_cluster_a11y", Res.string.people_map_cluster_a11y)
  map.put("people_map_leave", Res.string.people_map_leave)
}
